<template>
  <v-menu
    lazy
    full-width
    ref="menu"
    v-model="show"
    :nudge-right="27"
    max-width="290px"
    transition="scale-transition"
    :return-value.sync="dateValue"
    :close-on-content-click="false"
  >
    <v-text-field
      ref="textfield"
      v-bind="$attrs"
      readonly
      :label="label"
      slot="activator"
      :value="dateValue"
    ></v-text-field>
    <v-date-picker
      color="primary"
      :type="type"
      no-title
      :min="minDate"
      :locale="locale === 'dr' ? 'ps': locale"
      @input="changed"
      v-model="dateValue"
      :first-day-of-week="locale !== 'en' ? 6 : 0"
      :month-format="localMonth"
      :header-date-format="localMonthFormat"
    />
  </v-menu>
</template>
<script>
import LocalDate from "../libs/LocalDate";
export default {
  inheritAttrs: false,
  props: {
    label: {
      default: "Date"
    },
    value: {
      required: true
    },
    minDate: {
      default: null
    },
    type: {
      default: "date"
    }
  },
  data() {
    return {
      show: false,

      localMonthFormat: gerDate => {
        const date = new LocalDate(gerDate, this.locale);
        return this.type === "month"
          ? date.getYear()
          : date.getMonthNameShort() + " " + date.getYear();
      },

      localMonth: gerDate => {
        return new LocalDate(gerDate, this.locale).getMonthNameShort();
      }
    };
  },

  computed: {
    dateValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    locale() {
      return "en";
    }
  },

  methods: {
    changed(value) {
      this.$refs.menu.save(value);
    }
  }
};
</script>